import {
    FEEDBACK_SUBMITTED_SUCCESSFULY,
    FORMS_DEFAULT_REQUIRED_FIELD_ERROR,
    NO,
    SEND,
    WAS_THIS_ARTICLE_HELPFUL,
    WIKI_I_WAS_MISSING,
    WIKI_WE_ARE_HAPPY_ABOUT_IT,
    WIKI_WHAT_WAS_MISSING,
    WIKI_YES_THANK_YOU,
    WIKI_YOU_CAN_SHARE_YOUR_EXPERIENCE_WITH_title_BELOW,
} from 'mk/autogenerated/translations/FeedbackForm.ed42890aeafd7cd5d220fdc4e03ad549'
import { ArticleEntity } from 'mk2/apps/wiki/schemas';
import { BtnSidePadding, BtnType, default as Btn } from 'mk2/components/Btn';
import SubmitButton from 'mk2/components/forms/SubmitButton';
import TextareaField from 'mk2/components/forms/TextareaField';
import Like, { LikeType } from 'mk2/containers/Like/Like';
import { MKReduxFormInjectedProps, mkReduxFormNew } from 'mk2/helpers/form';
import { UserEntity } from 'mk2/schemas';
import { interpolate } from 'mk2/services/i18n';
import * as React from 'react';
import { FormErrors } from 'redux-form';
import styles from './FeedbackForm.mscss';

export const FEEDBACK_FORM_NAME = 'FEEDBACK_FORM';

export interface FeedbackFormData {
    text: string;
}

interface OwnState {
    showForm: boolean;
}

interface OwnProps {
    article: ArticleEntity;
    requestUser: UserEntity;
    isMobile: boolean;
    hideForm: boolean;
    onSave(articleSlug: string, categorySlug: string, values: FeedbackFormData);
}

type Props = OwnProps;

const validate = (values: FeedbackFormData) => {
    const errors: FormErrors<FeedbackFormData> = {};
    if (!values.text) {
        errors.text = FORMS_DEFAULT_REQUIRED_FIELD_ERROR;
    }
    return errors;
};

class FeedbackFormComponent extends React.Component<Props & MKReduxFormInjectedProps, OwnState> {

    constructor(props: Props & MKReduxFormInjectedProps) {
        super(props);

        this.state = {
            showForm: false,
        };
    }

    public render() {
        const { isMobile, article, hideForm, handleSubmit } = this.props;
        const likedByCurrentUser = article.likeable.isLiked;

        return (
            <div className={styles.FeedbackForm}>
                {!this.state.showForm && !likedByCurrentUser && (
                    <div className={styles.FeedbackForm__initialBox}>
                        <div className={styles.FeedbackForm__initialBox__header}>{WAS_THIS_ARTICLE_HELPFUL}</div>
                        <Like
                            className={styles.FeedbackForm__replyYes}
                            id={article.id}
                            entity="wiki-article"
                            type={LikeType.Label}
                            label={WIKI_YES_THANK_YOU}
                        />
                        <span className={styles.FeedbackForm__initialBox__sep}>&nbsp;/&nbsp;</span>
                        <Btn
                            key="helpful-no-btn"
                            onClick={this.onAnswerNo}
                            label={NO}
                            sidePadding={BtnSidePadding.None}
                            type={BtnType.BlueTextLight}
                            classNames={{
                                label: styles.FeedbackForm__initialBox__button,
                            }}
                        />
                    </div>
                )}
                {this.state.showForm && !hideForm && (
                    <div className={styles.FeedbackForm__formBox}>
                        <div className={styles.FeedbackForm__formBox__header}>{WIKI_WHAT_WAS_MISSING}</div>
                        <form className={styles.FeedbackForm__formBox__form} onSubmit={handleSubmit}>
                            <div className={styles.FeedbackForm__formBox__inputWrapper}>
                                <TextareaField
                                    name="text"
                                    label={WIKI_I_WAS_MISSING}
                                    rows={isMobile ? 5 : 10}
                                    bottomBorder={false}
                                    marginLeft={false}
                                />
                            </div>
                            <SubmitButton
                                label={SEND}
                                formName={FEEDBACK_FORM_NAME}
                                btnType={BtnType.Blue}
                            />
                        </form>
                    </div>
                )}
                {hideForm || likedByCurrentUser ? (
                    <div className={styles.FeedbackForm__text}>
                        {hideForm ?
                            <div className={styles.FeedbackForm__text__header}>{FEEDBACK_SUBMITTED_SUCCESSFULY}</div> :
                            <div className={styles.FeedbackForm__text__header}>{WIKI_WE_ARE_HAPPY_ABOUT_IT}</div>
                        }
                        {article.experiencesAllowed &&
                            <div>
                                {interpolate(WIKI_YOU_CAN_SHARE_YOUR_EXPERIENCE_WITH_title_BELOW, {title: article.instrumentalTitle})}
                            </div>
                        }
                    </div>
                ) : null}
            </div>
        );
    }

    private onAnswerNo = () => {
        this.setState({showForm: !this.state.showForm});
    };
}

const FeedbackForm = mkReduxFormNew<FeedbackFormData, Props>({
    formName: FEEDBACK_FORM_NAME,
    onValidate: validate,
    onSave: (values, props) => props.onSave(props.article.slug, props.article.category.slug, values),
})(FeedbackFormComponent);

export default FeedbackForm;
